import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronRight = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M16 27.9998L24 19.9998L16 11.9998"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

ChevronRight.propTypes = {onClick: PropTypes.func}

export default ChevronRight
